/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EdrOrgRequester } from './edrOrgRequester';


export interface OperatorOnPremEdrOrgSpec { 
    /**
     * The EDR region for on-premises deployment.
     */
    edr_region: string;
    /**
     * The organization ID for the vLCR provider.
     */
    vlcr_org_id: string;
    requester?: EdrOrgRequester;
}

